<template>
  <div class="outer" :class="{ highlight }">
    <div class="inner">
      <div class="title">{{ title }}</div>
      <div class="description">{{ description }}</div>
    </div>
    <div class="author">
      <img v-if="photo" :src="photo" />
      <img v-else src="app/assets/images/overlands/profiles/hero-elephant.png" />
      <span>{{ author }}</span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: String,
  description: String,
  author: String,
  photo: String,
  highlight: Boolean,
})
</script>

<style lang="scss" scoped>
.outer {
  text-align: left;
  max-width: 424px;
  border-radius: 24px;
  background-color: $grey-25;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  padding: 20px 20px 32px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  user-select: none;
}

.inner {
  height: 300px;
  overflow-y: auto;
  border-radius: 24px;
  padding: 24px;
  background: $white;
  @include flex-column(32px);
}

.title {
  color: $blue-500;
  font-size: 20px;
  font-weight: 600;
  line-height: 140%;
}

.description {
  color: $grey-300;
}

.author {
  display: flex;
  align-items: center;
  gap: 17px;
  color: $grey-300;
  font-size: 20px;
  font-weight: 600;
  line-height: 140%;

  img {
    width: 42px;
    aspect-ratio: 1/1;
    border-radius: 50%;
  }
}

.highlight {
  background-color: $brand-primary;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);

  .author {
    color: $white;
  }
}
</style>
